import React from 'react';

interface RoundTableWithInvoice {
    id: number;
    name: string;
    number: number;
    selected: boolean;
}

interface EmailWizardStep1Props {
    roundTablesWithInvoices: RoundTableWithInvoice[];
    loadingTables: boolean;
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    toggleTableSelection: (tableId: number) => void;
}

const EmailWizardStep1: React.FC<EmailWizardStep1Props> = ({
    roundTablesWithInvoices,
    loadingTables,
    searchQuery,
    setSearchQuery,
    toggleTableSelection,
}) => {
    const filteredTables = roundTablesWithInvoices.filter(table => {
        const query = searchQuery.toLowerCase();
        return (
            table.name.toLowerCase().includes(query) ||
            table.number.toString().includes(query)
        );
    });

    const selectedCount = roundTablesWithInvoices.filter(t => t.selected).length;

    return (
        <div className="wizard-step">
            <h3>Tischauswahl</h3>
            <p style={{ color: '#6c757d', marginBottom: '16px' }}>
                Wählen Sie die Round Tables aus, die die E-Mail erhalten sollen.
            </p>

            {/* Search Bar */}
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Suche nach Tischnummer oder Name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            {/* Selection Info */}
            <div className="selection-info">
                {selectedCount} von {roundTablesWithInvoices.length} Round Table(s) ausgewählt
            </div>

            {/* Scrollable Table List */}
            <div className="email-table-list-container">
                {loadingTables ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        Lade Round Tables...
                    </div>
                ) : filteredTables.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d' }}>
                        {searchQuery ? 'Keine Round Tables gefunden' : 'Keine Round Tables mit Rechnungen vorhanden'}
                    </div>
                ) : (
                    filteredTables.map(table => (
                        <label key={table.id} className="email-table-item">
                            <input
                                type="checkbox"
                                checked={table.selected}
                                onChange={() => toggleTableSelection(table.id)}
                            />
                            <span className="table-name">
                                {table.number} - {table.name}
                            </span>
                        </label>
                    ))
                )}
            </div>
        </div>
    );
};

export default EmailWizardStep1;
